module.exports = __webpack_public_path__ + "img/new-icon-selesai.f3e5e985.svg";